import { render, staticRenderFns } from "./pointsdetail.vue?vue&type=template&id=317a52a2&scoped=true&"
import script from "./pointsdetail.vue?vue&type=script&lang=js&"
export * from "./pointsdetail.vue?vue&type=script&lang=js&"
import style0 from "./pointsdetail.vue?vue&type=style&index=0&id=317a52a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a52a2",
  null
  
)

export default component.exports